export default "__VITE_ASSET__BVi2dErC__"